export default function({ route, store }) {
 	return store.dispatch('_getSeo');
}